import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

/**
 * React wrapper for Bryntum Calendar
 */
import React, { Component } from 'react';
import WrapperHelper from './WrapperHelper.js';
import { Calendar } from '@bryntum/calendar/calendar.umd';

var BryntumCalendar = /*#__PURE__*/function (_Component) {
  _inherits(BryntumCalendar, _Component);

  var _super = _createSuper(BryntumCalendar);

  function BryntumCalendar() {
    var _this;

    _classCallCheck(this, BryntumCalendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.dataStores = {
      "eventStore": "events",
      "resourceStore": "resources"
    };
    _this.featureNames = ['cellEditFeature', 'cellMenuFeature', 'cellTooltipFeature', 'columnAutoWidthFeature', 'columnDragToolbarFeature', 'columnLinesFeature', 'columnPickerFeature', 'columnReorderFeature', 'columnResizeFeature', 'contextMenuFeature', 'dependenciesFeature', 'dependencyEditFeature', 'eventContextMenuFeature', 'eventDragCreateFeature', 'eventDragFeature', 'eventDragSelectFeature', 'eventEditFeature', 'eventFilterFeature', 'eventMenuFeature', 'eventResizeFeature', 'eventTooltipFeature', 'excelExporterFeature', 'filterBarFeature', 'filterFeature', 'groupFeature', 'groupSummaryFeature', 'headerContextMenuFeature', 'headerMenuFeature', 'headerZoomFeature', 'labelsFeature', 'loadOnDemandFeature', 'nonWorkingTimeFeature', 'panFeature', 'pdfExportFeature', 'printFeature', 'quickFindFeature', 'regionResizeFeature', 'resourceTimeRangesFeature', 'rowReorderFeature', 'scheduleContextMenuFeature', 'scheduleMenuFeature', 'scheduleTooltipFeature', 'searchFeature', 'simpleEventEditFeature', 'sortFeature', 'stickyCellsFeature', 'stripeFeature', 'summaryFeature', 'timeAxisHeaderMenuFeature', 'timeRangesFeature', 'treeFeature', 'weekExpanderFeature'];
    _this.portalsCache = undefined;
    _this.portalContainerClass = 'b-react-portal-container';
    _this.state = {
      // Holds React portals
      portals: new Map(),
      // Needed to trigger refresh when portals change
      generation: 0
    };
    _this.configNames = ['adopt', 'align', 'allowOverlap', 'anchor', 'appendTo', 'autoCreate', 'bbar', 'bodyCls', 'centered', 'cls', 'config', 'constrainTo', 'contentElementCls', 'contextMenuTriggerEvent', 'crudManagerClass', 'dateFormat', 'defaultBindProperty', 'defaults', 'destroyStores', 'dock', 'draggable', 'enableDeleteKey', 'enableUndoRedoKeys', 'eventSelectionDisabled', 'floating', 'footer', 'header', 'hideAnimation', 'hideWhenEmpty', 'highlightDate', 'highlightPredecessors', 'highlightSuccessors', 'htmlCls', 'insertBefore', 'insertFirst', 'itemCls', 'lazyItems', 'listeners', 'loadMask', 'loadMaskDefaults', 'loadMaskError', 'localeClass', 'localizableProperties', 'maintainSelectionOnDatasetChange', 'maskDefaults', 'masked', 'modeDefaults', 'monitorResize', 'multiEventSelect', 'namedItems', 'nonWorkingDays', 'owner', 'positioned', 'preventTooltipOnTouch', 'ripple', 'rootElement', 'scrollAction', 'showAnimation', 'showRecurringUI', 'sidebar', 'strips', 'syncMask', 'tab', 'tag', 'tbar', 'textAlign', 'textContent', 'title', 'trapFocus', 'triggerSelectionChangeOnRemove', 'weekStartDay', 'weight'];
    _this.propertyConfigNames = ['alignSelf', 'content', 'crudManager', 'dataset', 'date', 'defaultCalendar', 'disabled', 'events', 'eventStore', 'extraData', 'flex', 'height', 'hidden', 'html', 'id', 'items', 'layout', 'layoutStyle', 'margin', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'mode', 'modes', 'onActiveItemChange', 'onAfterEventSave', 'onAssignmentSelectionChange', 'onBeforeActiveItemChange', 'onBeforeAssignmentDelete', 'onBeforeDestroy', 'onBeforeDragCreateEnd', 'onBeforeDragMoveEnd', 'onBeforeDragResizeEnd', 'onBeforeEventAdd', 'onBeforeEventDelete', 'onBeforeEventEdit', 'onBeforeEventEditShow', 'onBeforeEventSave', 'onBeforeHide', 'onBeforePrint', 'onBeforeSetRecord', 'onBeforeShow', 'onCatchAll', 'onCellOverflowClick', 'onDateRangeChange', 'onDayNumberClick', 'onDestroy', 'onDragCreateEnd', 'onDragMoveEnd', 'onDragResizeEnd', 'onEventClick', 'onEventSelectionChange', 'onFocusIn', 'onFocusOut', 'onHide', 'onMonthNameClick', 'onNavigate', 'onPaint', 'onReadOnly', 'onRefresh', 'onResize', 'onScheduleClick', 'onSelectionChange', 'onShow', 'onToolClick', 'onViewPaint', 'onWeekNumberClick', 'project', 'readOnly', 'resources', 'resourceStore', 'scrollable', 'tools', 'tooltip', 'width', 'x', 'y'];
    _this.propertyNames = ['activeView', 'anchorSize', 'isEngineReady', 'isSettingValues', 'isValid', 'record', 'selectedAssignments', 'selectedEvents', 'values', 'views'];
    _this.instance = undefined;
    _this.element = undefined;
    return _this;
  }

  _createClass(BryntumCalendar, [{
    key: "componentDidMount",
    value:
    /**
     * Invoked immediately after a component is mounted (inserted into the tree)
     */
    function componentDidMount() {
      var _WrapperHelper = WrapperHelper(),
          createWidget = _WrapperHelper.createWidget;

      this.instance = createWidget(this);
    } // React component removed, destroy instance

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.destroy();
      }
    }
    /**
     * Component about to be updated, from changing a prop using state.
     * React to it depending on what changed and prevent react from re-rendering our component.
     * @param nextProps
     * @param nextState
     * @return {boolean}
     */

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _WrapperHelper2 = WrapperHelper(),
          shouldComponentUpdate = _WrapperHelper2.shouldComponentUpdate;

      return shouldComponentUpdate(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = "b-react-".concat(this.constructor.instanceClass.$name.toLowerCase(), "-container");
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: function ref(element) {
          return _this2.element = element;
        }
      }, _toConsumableArray(this.state.portals).map(function (item) {
        return item[1];
      })), /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this2.portalsCache = el;
        },
        className: "b-react-portals-cache",
        style: {
          display: 'none'
        }
      }));
    }
  }]);

  return BryntumCalendar;
}(Component);

BryntumCalendar.instanceClass = Calendar;
BryntumCalendar.isView = true;
export { BryntumCalendar as default };